import { render } from 'preact';
import { App } from './app/App';
import { initEmbed } from './lib/embed';
import './styles.css';

initEmbed();
render(<App />, document.getElementById('app')!);
